import { useSelector } from '../../../react-redux';

const useTranslateData = () => {
  const translateData = useSelector(state => state.getIn(['translate', 'translateData']));

  return {
    translateData
  };
};

export default useTranslateData;
